import { Injectable, InjectionToken, PLATFORM_ID, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, map } from 'rxjs/operators';

import * as fromStore from '../store';
import { Observable, of } from 'rxjs';
import { isPlatformServer } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class NewsletterPopupSettingsGuard {
  private store = inject(Store);
  private platformId = inject<InjectionToken<any>>(PLATFORM_ID);

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    if (isPlatformServer(this.platformId)) {
      return of(true);
    }

    return this.store.select(fromStore.getNewsLetterShowWindowSettingsInitialized).pipe(
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.InitNewsletterPopup());
        }
      }),
      filter(loaded => loaded),
      map(loaded => loaded),
      take(1)
    );
  }
}
